import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import {
  DashboardOutlined,
  ShoppingOutlined,
  OrderedListOutlined,
  // ProfileOutlined,
  WalletOutlined,
  SafetyCertificateOutlined,
  CodeOutlined,
  SettingOutlined,
  CreditCardOutlined,
  WarningOutlined,
} from '@ant-design/icons'

const { Sider } = Layout
const DEFAULT_OPEN_KEYS = ['balance-group', 'developer-group']

interface SidebarProps {
  collapsed: boolean
  onNavigate: () => void
}

const menuItems = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined />,
    label: '儀表盤',
  },
  {
    key: '/dashboard/products',
    icon: <ShoppingOutlined />,
    label: '產品管理',
  },
  {
    key: '/dashboard/orders',
    icon: <OrderedListOutlined />,
    label: '訂單管理',
  },
  {
    key: '/dashboard/disputes',
    icon: <WarningOutlined />,
    label: '争议案件',
  },
  /*
  {
    key: '/dashboard/subscriptions',
    icon: <ProfileOutlined />,
    label: '訂閱管理',
  },
  */
  {
    key: '/dashboard/payment-methods',
    icon: <CreditCardOutlined />,
    label: '支付方式',
  },
  {
    key: 'balance-group',
    icon: <WalletOutlined />,
    label: '資金管理',
    children: [
      { key: '/dashboard/balance', label: '餘額概覽' },
      { key: '/dashboard/balance/transactions', label: '交易明細' },
      { key: '/dashboard/balance/refunds', label: '退款記錄' },
      { key: '/dashboard/payouts', label: '結款記錄' },
      { key: '/dashboard/bank-accounts', label: '銀行賬戶' },
    ],
  },
  {
    key: '/dashboard/kyb',
    icon: <SafetyCertificateOutlined />,
    label: 'KYB 認證',
  },
  {
    key: '/dashboard/kyc',
    icon: <SafetyCertificateOutlined />,
    label: '個人 KYC',
  },
  {
    key: 'developer-group',
    icon: <CodeOutlined />,
    label: '開發者工具',
    children: [
      { key: '/dashboard/developers/api-keys', label: 'API Keys' },
      { key: '/dashboard/developers/webhooks', label: 'Webhooks' },
      { key: 'https://docs.kyrenpay.com/', label: '文檔中心' },
    ],
  },
  {
    key: '/dashboard/settings',
    icon: <SettingOutlined />,
    label: '設定',
  },
]

export default function Sidebar({ collapsed, onNavigate }: SidebarProps) {
  const navigate = useNavigate()
  const location = useLocation()
  const [openKeys, setOpenKeys] = useState<string[]>(DEFAULT_OPEN_KEYS)

  useEffect(() => {
    if (!collapsed) setOpenKeys(DEFAULT_OPEN_KEYS)
  }, [collapsed])

  const handleMenuClick = ({ key }: { key: string }) => {
    if (key.startsWith('http')) {
      window.open(key, '_blank', 'noopener,noreferrer')
    } else if (!key.includes('-group')) {
      navigate(key)
      onNavigate()
    }
  }

  const handleOpenChange = (keys: string[]) => {
    if (!collapsed) setOpenKeys(keys)
  }

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      collapsedWidth={0}
      theme="dark"
      className="dashboard-sidebar"
    >
      <div className="sidebar-logo">
        <span className="sidebar-logo-icon">⚡</span>
        {!collapsed && <span className="sidebar-logo-text">啟潤充值中心</span>}
      </div>
      <Menu
        mode="inline"
        theme="dark"
        selectedKeys={[location.pathname]}
        openKeys={collapsed ? [] : openKeys}
        items={menuItems}
        onOpenChange={handleOpenChange}
        onClick={handleMenuClick}
      />
    </Sider>
  )
}
